import { render, staticRenderFns } from "./AviaPlayer.vue?vue&type=template&id=543e5be0&"
import script from "./AviaPlayer.vue?vue&type=script&lang=js&"
export * from "./AviaPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AviaPlayer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports